
import ModifiedOrderDialog from "../../components/dialogs/modified-order-dialog.vue";
import { mapState } from "vuex";

export default {
  components: {
    ModifiedOrderDialog
  },

  data: () => {
    return {
      showModifiedOrderDialog: false
    };
  },
  computed: {
    ...mapState("reciever", ["onHoldOrders"])
  },

  methods: {
    handleClick() {
      this.showModifiedOrderDialog = true;
    }
  }
};
